// src/components/StatusStrip.tsx
import { useEffect, useState } from "react";
import { NETWORK_STATUS } from "../data/content.js";

const BADGE_STYLES: Record<string, { bg: string; color: string; border: string }> = {
  green:  { bg: "rgba(16,185,129,.15)",  color: "#34d399", border: "rgba(16,185,129,.3)" },
  cyan:   { bg: "rgba(6,182,212,.15)",   color: "#67e8f9", border: "rgba(6,182,212,.3)"  },
  purple: { bg: "rgba(124,58,237,.15)",  color: "#a78bfa", border: "rgba(124,58,237,.3)" },
};

const SPARK_POINTS = [18,14,16,10,12,8,10,6,8];

export default function StatusStrip() {
  const [block, setBlock] = useState<string>("—");
  const [gas, setGas]     = useState<string>("—");

  useEffect(() => {
    async function fetch_() {
      const RPCS = ["https://rpc.meechain.run.place","https://rpc.meechain.live"];
      for (const url of RPCS) {
        try {
          const [b, g] = await Promise.all([
            fetch(url,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({jsonrpc:"2.0",method:"eth_blockNumber",params:[],id:1}),signal:AbortSignal.timeout(5000)}).then(r=>r.json()),
            fetch(url,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({jsonrpc:"2.0",method:"eth_gasPrice",params:[],id:2}),signal:AbortSignal.timeout(5000)}).then(r=>r.json()),
          ]);
          if (b.result) setBlock(parseInt(b.result,16).toLocaleString("en"));
          if (g.result) setGas((parseInt(g.result,16)/1e9).toFixed(3)+" Gwei");
          return;
        } catch {}
      }
    }
    fetch_();
    const id = setInterval(fetch_, 12000);
    return () => clearInterval(id);
  }, []);

  const displayVals: Record<string, string> = {
    rpc: block !== "—" ? "99.98%" : "99.98%",
    explorer: "LIVE",
    api: "98.7%",
    faucet: "LIVE",
    contracts: "24",
  };
  const displayUrls: Record<string, string> = {
    rpc: block !== "—" ? `block ${block}` : "https://rpc.meechain.live",
  };

  return (
    <div style={{
      margin: "0 32px 24px", background: "var(--bg2)",
      border: "1px solid rgba(124,58,237,.25)", borderRadius: 12, overflow: "hidden",
      position: "relative", zIndex: 1,
    }}>
      {/* Header */}
      <div style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 20px 0", fontSize:11, fontWeight:700, color:"var(--muted)", letterSpacing:".12em", textTransform:"uppercase" }}>
        NETWORK STATUS
        <div style={{ width:7, height:7, borderRadius:"50%", background:"#34d399", boxShadow:"0 0 8px #10b981", animation:"blink 2s infinite" }} />
        <span style={{ color:"#34d399", fontFamily:"var(--mono)", fontSize:10 }}>LIVE</span>
      </div>

      {/* Grid */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)" }}>
        {NETWORK_STATUS.map((item, i) => {
          const bs = BADGE_STYLES[item.badgeStyle] ?? BADGE_STYLES.green;
          const val = displayVals[item.id] ?? item.value;
          const url = displayUrls[item.id] ?? item.url;
          return (
            <div key={item.id} style={{
              padding:"14px 20px 16px",
              borderRight: i < NETWORK_STATUS.length-1 ? "1px solid rgba(124,58,237,.1)" : "none",
            }}>
              <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:4, fontSize:10, fontWeight:700, color:"var(--muted)", letterSpacing:".08em", textTransform:"uppercase" }}>
                <span style={{ fontSize:13 }}>{item.icon}</span>{item.label}
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:6, fontSize:18, fontWeight:700, fontFamily:"var(--display)", color: item.badgeStyle==="green" ? "#34d399" : item.badgeStyle==="cyan" ? "#67e8f9" : "#fff" }}>
                {val}
                <span style={{ fontSize:9, fontWeight:700, padding:"1px 7px", borderRadius:4, background:bs.bg, color:bs.color, border:`1px solid ${bs.border}` }}>
                  {item.badge}
                </span>
              </div>
              <div style={{ fontSize:10, fontFamily:"var(--mono)", color:"rgba(107,104,136,.6)", marginTop:2, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                {url}
              </div>
              <svg width="80" height="22" viewBox="0 0 80 22" style={{ marginTop:4 }}>
                <polyline
                  fill="none" strokeWidth="1.5" strokeLinecap="round"
                  stroke={item.sparkColor}
                  points={SPARK_POINTS.map((y,xi) => `${xi*10},${y}`).join(" ")}
                />
              </svg>
            </div>
          );
        })}
      </div>
    </div>
  );
}
